import { apiPost } from '../../api'

export const add_or_update_task = data => {
  return apiPost({
    endpoint: 'tasks/create_task',
    data: data
  })
}
